import React from 'react';
import {getIcon} from "../../styles/icons";
import './GlobalNotification.css';

const GlobalNotification = ({message, onClose}) => {
  return (
    <div className="global-notification">
      <div className="notification__icon">
        {getIcon('bell')}
      </div>
      <p>{message}</p>
      <div className="notification__close" onClick={onClose}>
        {getIcon('wrong')}
      </div>
    </div>
  );
};

export default GlobalNotification;